import { parseToHtml } from "@/utility/parseToHtml";

// Only <a> href values are editable; everything else in the markup is left untouched.
const collectSlots = html => {
  const doc = parseToHtml(html || "");
  const slots = [];

  doc.body.querySelectorAll("a[href]").forEach(el => {
    slots.push({ value: el.getAttribute("href") || "", write: value => el.setAttribute("href", value) });
  });

  return { doc, slots };
};

const replaceInContent = (html, search, replace) => {
  if (!search) return html;

  const { doc, slots } = collectSlots(html);

  slots.forEach(slot => {
    if (slot.value.includes(search)) {
      slot.write(slot.value.split(search).join(replace));
    }
  });

  return doc.body.innerHTML;
};

const scanContent = (html, search, options = {}) => {
  const context = options.context ?? 12;
  const maxSnippets = options.maxSnippets ?? 20;

  if (!search) return { count: 0, snippets: [] };

  let count = 0;
  const snippets = [];

  collectSlots(html).slots.forEach(({ value: text }) => {
    let index = text.indexOf(search);

    while (index !== -1) {
      count += 1;

      if (snippets.length < maxSnippets) {
        const start = Math.max(0, index - context);
        const end = Math.min(text.length, index + search.length + context);

        snippets.push({
          before: (start > 0 ? "..." : "") + text.slice(start, index),
          match: text.slice(index, index + search.length),
          after: text.slice(index + search.length, end) + (end < text.length ? "..." : ""),
        });
      }

      index = text.indexOf(search, index + search.length);
    }
  });

  return { count, snippets };
};

export { replaceInContent, scanContent };
